import client from "./client";

export const powerbiApi = {
  getStatus: () => client.get("/powerbi/status").then((r) => r.data),
  getAuthorizeUrl: () => client.get("/powerbi/authorize").then((r) => r.data.auth_url),
  disconnect: () => client.delete("/powerbi/disconnect").then((r) => r.data),
};
